import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchMeetingTypes } from "./api"

export function useMeetingTypes(options: { enabled?: boolean } = {}) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["meeting-types"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchMeetingTypes(context)
    },
    enabled: options.enabled ?? true,
  })
}
